import {API_ENDPOINTS, LoadingKeys} from '@/constants';

import {IBalanceData} from '@/models';
import {create} from 'zustand';
import {handleApiCallInStore} from './utils';
import {http} from '@/utils';
import {persist} from 'zustand/middleware';

export interface IBalanceStore {
  totalBalance: number;
  getTotalBalance: () => void;
}

export const useBalanceStore = create(
  persist<IBalanceStore>(
    set => ({
      totalBalance: 0,
      getTotalBalance: async () => {
        handleApiCallInStore(LoadingKeys.GetAllBalance, async () => {
          const {data} = await http.get<IBalanceData>(API_ENDPOINTS.balance);
          const {totalDuedBalance = 0} = data || {};
          set(() => ({totalBalance: totalDuedBalance}));
        });
      },
    }),
    {
      name: 'balance-storage',

    }
  )
);
